'use strict';

module.exports.coworking_place_types = [{
  value: 'c_open_coworking_space',
  label: 'myWO Lib',
  front_label: 'myWO Lib',
  front_short_label: 'Lib',
  widget_label: 'myWO Lib - Coworking animé',
  new_value: 'lib',
  TC_value: 'c_open_coworking_space'
}, {
  value: 'a_calm_coworking_space',
  label: 'myWO Lounge',
  front_label: 'myWO Lounge',
  front_short_label: 'Lounge',
  widget_label: 'myWO Lounge - Coworking privé',
  new_value: 'lounge',
  TC_value: 'a_calm_coworking_space'
}, {
  value: 'b_seminar',
  label: 'myWO Meeting',
  front_label: 'myWO Meeting',
  front_short_label: 'Meeting',
  widget_label: 'myWO Meeting - Salles de réunion',
  new_value: 'meeting',
  TC_value: 'b_seminar'
}];

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
**/
module.exports.coworking_place_equipments = [{
  value: "WIFI",
  label: "WIFI"
}, {
  value: "Chargeurs Téléphone/PC",
  label: "Chargeurs Téléphone/PC"
}, {
  value: "Impression/Photocopie/Scanner"
}, {
  value: "Vidéoprojection"
}, {
  value: "Paperboard"
}, {
  value: "Lumière du jour"
}, {
  value: "Climatisation"
}, {
  value: "Ouvert le weekend"
}, {
  value: "Accès PMR"
}, {
  value: "Snacking",
  label: "Snacking"
}];

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
**/
module.exports.etablishment_equipments = [{
  value: "Bagagerie",
  email_icon_name: 'icone_bagagerie.png'
}, {
  value: "Bar",
  email_icon_name: 'icone_bar.png'
}, {
  value: 'borne',
  label: 'Borne de recharge électrique',
  email_icon_name: 'icone_borne.png'
}, {
  value: "Conciergerie",
  email_icon_name: 'icone_conciergerie.png'
}, {
  value: 'wellness',
  label: 'Espace Bien-être',
  email_icon_name: 'icone_spa.png'
}, {
  value: "Fitness",
  email_icon_name: 'icone_fitness.png'
}, {
  value: "Parking gratuit",
  email_icon_name: 'icone_parking.png'
}, {
  value: "Parking payant",
  email_icon_name: 'icone_parking.png'
}, {
  value: "Piscine",
  email_icon_name: 'icone_piscine.png'
}, {
  value: "Restaurant",
  email_icon_name: 'icone_restaurant.png'
}, {
  value: 'spa',
  label: 'Spa',
  email_icon_name: 'icone_spa.png'
}, {
  value: "Terrasse",
  email_icon_name: 'icone_terrasse.png'
}];

/**
 * /!\ --------------------------- /!\
 * /!\ Sync toute modif avec l'API /!\
 * /!\ --------------------------- /!\
**/
module.exports.coworking_place_hybrid_equipments = [{
  value: "Micro"
}, {
  value: "Caméra"
}, {
  value: "Enceinte"
}, {
  value: "Ecran intelligent"
}, {
  value: "Haut débit"
}];
module.exports.days_config = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const b_seminar_type = module.exports.coworking_place_types.find(opt => opt.value === 'b_seminar');
module.exports.widgets_types = [{
  label: 'Tous nos espaces',
  value: 'all'
}, {
  label: 'Coworking (espaces Lib et Lounge)',
  value: 'coworking'
}, {
  label: 'Séminaire (espace Meeting)',
  value: b_seminar_type.value
}];
module.exports.b_seminar_ranges = [{
  value: 'morning',
  label: 'Matin'
}, {
  value: 'afternoon',
  label: 'Après-midi'
}, {
  value: 'day',
  label: 'Journée'
}];
module.exports.b_seminars_config = {
  u: {
    title: 'Disposition en U',
    short_title: 'U'
  },
  classe: {
    title: 'Disposition en classe',
    short_title: 'classe'
  },
  board: {
    title: 'Disposition en table ronde',
    short_title: 'board'
  },
  theater: {
    title: 'Disposition en théâtre',
    short_title: 'théâtre'
  },
  island: {
    title: 'Disposition en îlots',
    short_title: 'îlots'
  }
};
module.exports.pack_status = [{
  value: 'active',
  label: 'Actif'
}, {
  value: 'non_active',
  label: 'Non actif'
}, {
  value: 'waiting_validation',
  label: 'En attente de validation'
}, {
  value: 'out_of_stock',
  label: 'Épuisé'
}, {
  value: 'expired',
  label: 'Expiré'
}];
module.exports.service_units = [{
  value: 'per_hour',
  label: 'L\'heure'
}, {
  value: 'per_booking',
  label: 'La réservation'
}, {
  value: 'customer_qty',
  label: 'La quantité'
}].map(function (opt) {
  opt.full_label = 'À ' + opt.label.toLowerCase();
  return opt;
});
module.exports.service_VATs = [{
  label: '0',
  value: '0'
}, {
  label: '5.5',
  value: '1.055'
}, {
  label: '10',
  value: '1.10'
}, {
  label: '20',
  value: '1.2'
}, {
  label: 'Multiple',
  value: 'multiple'
}];
module.exports.service_categories = [{
  value: 'restauration',
  label: 'Restauration'
}, {
  value: 'fitness',
  label: 'Fitness'
}, {
  value: 'parking',
  label: 'Parking'
}, {
  value: 'spa',
  label: 'Bien-être'
}, {
  value: 'autres',
  label: 'Autres'
}];
module.exports.dashboards_status = [{
  value: 'all',
  label: 'Toutes les réservations'
}, {
  value: 'paid',
  label: 'Réglée'
},
//Pour les espaces lib
{
  value: 'confirmed',
  label: 'Confirmée'
}, {
  value: 'canceled',
  label: 'Annulée'
}, {
  value: 'pending',
  label: 'En cours de paiement'
}, {
  value: 'expired',
  label: 'Expiré'
}];
module.exports.discount_code_types = [{
  value: 'every_myWO',
  label: 'Tous les myWO'
}, {
  value: 'excluded_myWO',
  label: 'Tous les myWO sauf une sélection'
}, {
  value: 'myWO',
  label: 'Une sélection de myWO'
}, {
  value: 'postal_code',
  label: 'Tous les myWO d\'un code postal'
}];
